import type { ChangeEvent } from 'react';
import { type FC } from 'react';
import type { Control, UseFormResetField, UseFormWatch } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { Select } from '@cencosud-cencommerce/paris-uikit';

import useCommunesOptions from './hooks/useCommunesOption';
import useRegionsOptions from './hooks/useRegionsOptions';
import type { RegionFormValues } from './RegionFormValues';

interface Props {
  control: Control<RegionFormValues>;
  watch: UseFormWatch<RegionFormValues>;
  resetField: UseFormResetField<RegionFormValues>;
  onChangeComuna: (event: ChangeEvent<HTMLInputElement>) => void;
  'data-testid'?: string;
  onSelectRegion(region: string): void;
}

const IS_REGION_DISABLED = false;

const RegionForm: FC<Props> = ({
  control,
  watch,
  resetField,
  onChangeComuna,
  onSelectRegion,
  'data-testid': dataTestId = 'paris-addressform'
}) => {
  const regionOptions = useRegionsOptions();
  const communeOptions = useCommunesOptions(watch('region'));

  return (
    <div className="co-flex co-flex-col co-gap-6" data-testid={dataTestId}>
      <div className="co-flex co-gap-6 co-flex-col">
        <Controller
          control={control}
          name="region"
          render={({ field, fieldState, formState }) => (
            <Select
              {...field}
              options={regionOptions}
              label="Región"
              disabled={IS_REGION_DISABLED}
              helperText={fieldState.error?.message}
              onChange={(e) => {
                resetField('commune');
                const value = e.target.value;
                onSelectRegion(
                  regionOptions.find((r) => r.value === value)?.label || ''
                );
                field.onChange(value);
              }}
              status={
                (formState.isSubmitted &&
                  (fieldState.invalid ? 'error' : 'validated')) ||
                undefined
              }
            />
          )}
        />
        <Controller
          control={control}
          name="commune"
          render={({ field, fieldState, formState }) => (
            <Select
              {...field}
              options={communeOptions}
              label="Comuna"
              disabled={!watch('region')}
              helperText={fieldState.error?.message}
              status={
                (formState.isSubmitted &&
                  (fieldState.invalid ? 'error' : 'validated')) ||
                undefined
              }
              onChange={(e) => {
                field.onChange(e);
                onChangeComuna(e);
              }}
            />
          )}
        />
      </div>
    </div>
  );
};

export default RegionForm;
